import { render, staticRenderFns } from "./already.vue?vue&type=template&id=2b9f6464&scoped=true&"
import script from "./already.vue?vue&type=script&lang=js&"
export * from "./already.vue?vue&type=script&lang=js&"
import style0 from "./already.vue?vue&type=style&index=0&id=2b9f6464&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9f6464",
  null
  
)

export default component.exports